"use client"; 

import "../public/scss/main.scss";
import "photoswipe/dist/photoswipe.css";
import "rc-slider/assets/index.css";
import "../public/css/admin.css";
import "react-toastify/dist/ReactToastify.css";

import { useEffect } from "react";

import Script from "next/script";
import ClientShell from "@/components/layout/ClientShell";
import GoogleAnalytics from "@/components/layout/GoogleAnalytics";
import AIAsistent from "@/components/AIAsistent";
import { Suspense } from "react";

export default function RootLayout({ children }) {
     useEffect(() => {
          import("bootstrap/dist/js/bootstrap.esm").catch(() => {});
     }, []);


	return (
		<html lang='ro' dir='ltr' suppressHydrationWarning>
			<head>
				<Script id="gtm-script" strategy="afterInteractive">
					{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
					new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
					'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
					})(window,document,'script','dataLayer','GTM-5WR5FT74');`}
				</Script>
			</head>
			<body className='preload-wrapper' dir='ltr' suppressHydrationWarning>
				<noscript>
					<iframe
						src="https://www.googletagmanager.com/ns.html?id=GTM-5WR5FT74"
						height="0"
						width="0"
						style={{ display: "none", visibility: "hidden" }}
					/>
				</noscript>
                    <Suspense fallback={null}>
                         <GoogleAnalytics />
                    </Suspense>
				<ClientShell>{children}</ClientShell>
                <AIAsistent />
			</body>
		</html>
	);
}
